import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import TabPanel from "../Reusable/Tab";
import UpdateAddress from "./Address";
import AssignGroup from "./AssignGroup";
import BankDetails from "./BankDetails";
import ChangePassword from "./ChangePassword";
import UpdateUserProfile from "./EditUserProfile";
import EmailSettings from "./EmailSettings";
import LoginLimit from "./LoginLimit";
import UserLoginInfo from "./UserLoginInfo";
//@ts-ignore
import { FileUpload } from "@careinfo/file-upload-service";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import Organization from "./Organization";
import {
  AccessControl,
  ClientAccessControl,
} from "@careinfo/permission-required";
const UpdateUser = (props: any) => {
  const { data, roles, profile, bankData, email } = props;
  const { data: addressData, refetch } = useGetHook({
    queryKey: ["address", `address-${data?.id}`],
    url: APIS.ADDRESS,
    params: {
      user: data?.id,
    },
  });

  return (
    <ClientAccessControl
      allowedPermissions={["can_assign_organization"]}
      renderNoAccess={
        <TabPanel
          tabTitle={[
            "Update User",
            // "Profile",
            "Roles",
            // "Address",
            "Change Password",
            "Bank Details",
            "Documents",
            "Login Limit",
            "Email Settings",
          ]}
          tabPanels={[
            <>
              <UserLoginInfo refetch={refetch} user={data} profile={profile} />
            </>,
            // <>
            //   <UpdateUserProfile user={data} />
            // </>,
            <>
              <AssignGroup roles={roles} user={data} />
            </>,

            // <>
            //   <UpdateAddress refetch={refetch} id={addressData?.[0]?.id} />
            // </>,
            <>
              <div className={tw` max-w-md`}>
                <ChangePassword user={data} email={data?.email} />
              </div>
            </>,
            <>
              <BankDetails user={data} bankData={bankData} />
            </>,
            <>
              <FileUpload object_id={data?.id} />
            </>,
            <>
              <LoginLimit refetch={refetch} user={data} />
            </>,
            <EmailSettings user={data} email={email} />,
          ]}
        />
      }
    >
      <TabPanel
        tabTitle={[
          "Update User",
          // "Profile",
          "Roles",
          // "Address",
          "Change Password",
          "Bank Details",
          "Documents",
          "Login Limit",
          "Email Settings",
          "Organization",
        ]}
        tabPanels={[
          <>
            <UserLoginInfo refetch={refetch} user={data} profile={profile} />
          </>,
          // <>
          //   <UpdateUserProfile user={data} />
          // </>,
          <>
            <AssignGroup roles={roles} user={data} />
          </>,

          // <>
          //   <UpdateAddress refetch={refetch} id={addressData?.[0]?.id} />
          // </>,
          <>
            <div className={tw` max-w-md`}>
              <ChangePassword user={data} email={data?.email} />
            </div>
          </>,
          <>
            <BankDetails user={data} bankData={bankData} />
          </>,
          <>
            <FileUpload object_id={data?.id} />
          </>,
          <>
            <LoginLimit refetch={refetch} user={data} />
          </>,
          <EmailSettings user={data} email={email} />,
          <Organization />,
        ]}
      />
    </ClientAccessControl>
  );
};

export default UpdateUser;
